module.exports = __webpack_public_path__ + "static/media/ios@2x.7888b779.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/uq-ui/components/store-button/img/ios@2x.png
// module id = 1119
// module chunks = 0